'use client';

import { useEffect, useRef } from 'react';
import { useBoardEditorStore } from '@/stores/useBoardEditorStore';

export default function BoardLogConsole() {
    const logs = useBoardEditorStore((s) => s.logs);
    const boxRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (boxRef.current) {
            boxRef.current.scrollTop = boxRef.current.scrollHeight;
        }
    }, [logs]);

    return (
        <div
            ref={boxRef}
            className="w-full h-full p-2 overflow-y-auto font-cantarell text-color-white-base text-xs rounded-none bg-black"
        >
            {logs.length === 0 && <div className=""></div>}
            {logs.map((l, i) => {
                const match = l.match(/^(\d{1,2}:\d{2}:\d{2}\.\d{3})\s+([\s\S]*)$/);
                const ts = match?.[1];
                const msg = match?.[2] ?? l;
                return (
                    <div key={i} className="whitespace-pre-wrap leading-tight">
                        {ts && <span className="text-gray-300 select-none mr-4">{ts}</span>}
                        <span>{msg}</span>
                    </div>
                );
            })}
        </div>
    );
}
